import * as React from 'react';
import TextField, { TextFieldProps } from '@material-ui/core/TextField';
import './Input.css';

const Input: React.FunctionComponent<TextFieldProps> = props => {
	return <TextField
		{...props}
		variant="filled"
		fullWidth={true}
		InputLabelProps={{
			classes: {
				root: 'input__label',
				shrink: 'input__label_shrink',
				focused: 'input__label_focused'
			}
		}}
		InputProps={{
			...props.InputProps,
			disableUnderline: true,
			classes: {
				root: 'input',
				focused: 'input_focused'
			}
		} as any}
	/>;
};

export default Input;
